import { useLayoutEffect } from 'react';

export const useResetScrollPosition = (condition: boolean) => {
  useLayoutEffect(() => {
    if (typeof window !== 'undefined' && condition) {
      window.scrollTo(0, 0);
    }
  }, []);
};
